/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "search/cache/visibility/models.proto" (package "rd.search.cache.visibility", syntax proto3)
// tslint:disable
// @ts-nocheck
/**
 * Visibility indicates whether data is company-specific or globally shared - used for search
 * updates
 *
 * @generated from protobuf enum rd.search.cache.visibility.Visibility
 */
export enum Visibility {
    /**
     * @generated from protobuf enum value: VISIBILITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: VISIBILITY_COMPANY = 1;
     */
    COMPANY = 1,
    /**
     * @generated from protobuf enum value: VISIBILITY_GLOBAL = 2;
     */
    GLOBAL = 2
}
